import { ShippingInfoFormValuesType } from './types';
import { UPDATE_SHIPPING_INFORMATION_VARIABLES } from '@global/requests/checkout/UPDATE_SHIPPING_INFORMATION';

export function mapShippingInfoToServer(
  shippingInfo: ShippingInfoFormValuesType
): Omit<UPDATE_SHIPPING_INFORMATION_VARIABLES, 'orderUid'> {
  return {
    shippingOption: {
      selectedDeliveryOption: shippingInfo.deliveryOption.id,
      start: shippingInfo.deliveryOption.date.from,
      end: shippingInfo.deliveryOption.date.to,
    },
    address: {
      uid: shippingInfo.uid,
      upaEmail: shippingInfo.email,
      upaCity: shippingInfo.city,
      upaLine1: shippingInfo.address1,
      upaLine2: shippingInfo.address2,
      upaPhoneNumber: shippingInfo.phone,
      upaPostcode: shippingInfo.zip,
      wCountry: shippingInfo.country,
      wFirstName: shippingInfo.firstName,
      wLastName: shippingInfo.lastName,
      wNewAddress: shippingInfo.wNewAddress,
      gadStateOrProvince: shippingInfo.state,
    },
  };
}
